import { Model } from '@nozbe/watermelondb'
import { field, json } from '@nozbe/watermelondb/decorators'


const sanitizeData = rawData => rawData
export class ProductGroupModel extends Model {

  static table = 'productGroup'

  @field('productGroupId')
  productGroupId: string

  @field('name')
  name: string

  @field('description')
  description: string

  @field('slug')
  slug: String

  @json('crops', sanitizeData)
  crops

  @field('createdAt')
  createdAt: string
}
